import { render, staticRenderFns } from "./cpt-dataV-scrollTable-option.vue?vue&type=template&id=7dd5a044&scoped=true"
import script from "./cpt-dataV-scrollTable-option.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-scrollTable-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd5a044",
  null
  
)

export default component.exports